import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { authAPIBase } from 'app/utilities/env';
import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import axios, { AxiosRequestConfig } from 'axios';
import { signOutRequest } from 'features/auth/redux/auth-slice';
import { toast } from 'react-toastify';

import { ChangePasswordDTO } from '../types/password';

const axiosInstance = axios.create({ baseURL: authAPIBase });

export const changeUserPassword = createAsyncThunk(
  'settings/changeUserPassword',
  async (data: ChangePasswordDTO, { getState, rejectWithValue, dispatch }) => {
    const {
      user: { accessToken },
    } = getState() as RootState;

    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      await axiosInstance.post('/user/update-password', data, config);
      return 'Password changed successfully.';
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response && error.response.status === 401) {
          toast('Your session expired!', {
            type: 'error',
            position: 'top-left',
          });
          dispatch(signOutRequest());
          return rejectWithValue(getServerErrorMessage(null));
        }
      }

      return rejectWithValue(getServerErrorMessage(error));
    }
  }
);
